import { IAddress } from "./address";

export interface IFiscalSetup {
  version?: number;
  isDeactivated?: boolean;
  id?: number;
  fiscalSetupType?: string;
  color?: string;
  orgNumber?: string;
  address?: IAddress;
  logoId?: number;
  workScheduleId?: number;
  accountantId?: number;
  defaultSalesVatId?: number;
  defaultPurchasingVatId?: number;
  defaultEUVatGoodsId?: number;
  defaultEUVatServicesId?: number;
  currencyAbbreviation?: string;
  appointmentSetupColour?: string;
  paymentLedgerTagId?: number;
  paymentLedgerTagNumber?: number;
  culture?: string;
  lightHighlightColour?: string;
  darkHighlightColour?: string;
  darkHighlightTextColour?: string;
  invertedTextColour?: string;
  phone?: string;
  email?: string;
  website?: string;
  accountantDepartmentId?: number;
  ledgerId?: number;
  registeredForVat?: boolean;
  dibsMerchantId?: number;
  providerId?: number;
  providerName?: string;
  providerCssClass?: string;
  hasArchive?: boolean;
  xenaSubscriptionId?: number;
  isMD5KeyEntered?: boolean;
  hasExpiringFiscalPeriod?: boolean;
  hasExpiringDiscountCodes?: boolean;
  isProvider?: boolean;
  sproomKey?: string;
  resourceId?: number;
  recipientAddressType?: string;
  isXenaSubscriptionActive?: boolean;
  accountantName?: string;
  defaultSalesVatAbbreviation?: string;
  defaultPurchasingVatAbbreviation?: string;
  defaultEUVatGoodsAbbreviation?: string;
  defaultEUVatServicesAbbreviation?: string;
  paymentLedgerTagDescription?: string;
  departmentDescription?: string;
  ledgerDescription?: string;
  accountantDepartmentDescription?: string;
  usesSproom?: boolean;
  currencyDescription?: string;
  cultureDisplayName?: string;
  isAccountant?: boolean;
  isFacade?: boolean;
  agreementNumber?: string;
  createdAt?: string;
  accountPlanTemplateId?: number;
}
